import { render } from "./studentTree.vue?vue&type=template&id=1a75ce58&scoped=true"
import script from "./studentTree.vue?vue&type=script&lang=js"
export * from "./studentTree.vue?vue&type=script&lang=js"

import "./studentTree.vue?vue&type=style&index=0&id=1a75ce58&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a75ce58"]])

export default __exports__